module.exports = __webpack_public_path__ + "img/iPhone6plus-5.5-Landscape.500f5a10.png";